<template>
	<div class="list-page">
		
		<!-- 列表 -->
		<section class="page-ctn w1200">
			<div class="page-main">
				<!-- 面包屑 -->
				<div class="bread-crumbs" style="border-bottom:1px solid #ccc;">
					<a href="javascript:;" @click="goUrl({name:'pageIndex'})">首页</a> / <p>{{newsListInfo.catename}}</p>
				</div>
				
				<div class="tit-img"><img src="../../assets/img/detail-tit.png" alt=""></div>
				<div class="list-cont clearfix">
					<!-- 主栏 -->
					<div class="list-main">
						
						<ul class="news-list" v-if="newsListInfo.list">
							<li v-for="(item2,index2) in newsListInfo.list.list" :key="item2.id" @click="goUrl({ name:'pageDetail', params:{ id:item2.id}})">
								<span class="date">{{item2.inputtime}}</span>
								<i class="dot"></i><p>{{item2.title}}</p>
							</li>
						</ul>
						
						<div class="paging" v-if="newsListInfo.list">
							<span class="prev" :class="{show:pageNum>1}" v-if="pageNum>1" @click="changeList(pageNum-1)">上一页</span>
							<span class="num" :class="{act:item==pageNum}" v-for="(item,index) in pagingList" :key="index" @click="changeList(item)">{{item}}</span>
							<span class="next" :class="{show:pageNum < pageLen}" v-if="pageNum<pageLen" @click="changeList(pageNum+1)">下一页</span>
							<p>共{{newsListInfo.list.total}}条</p>
						</div>
					</div>
				</div>
				
			</div>
		</section>
		
		
	</div>
</template>

<script>
import pageMixin from '@/mixins/page.js'
export default {
	mixins: [pageMixin],
	name: 'pageIndex',
	data () {
		return {
			catid:'',
			newsListInfo:{},
			pageNum:1,
			pageSize:10,
			pageLen:0,	//总页数
		}
	},
	
	computed:{
		pagingList(){
			var pagList = []
			for(var i=0; i<this.pageLen; i++){
				pagList.push(i+1)
			}
			return pagList
		}
	},
	
	created(){
		this.catid = this.$route.params.catid
		this.getListInfo()
	},

	
	//防止
	beforeRouteUpdate (to, from, next) {
		this.catid = to.params.catid?to.params.catid:''
		this.getListInfo()
		next() // 一定要有next
	},
  
	methods:{
		//获取列表
		getListInfo(){
			if(this.listLoading){return}
			this.listLoading = true
			this.$axios({
				url:'/index.php?s=common&c=api&m=getNewList',
				params:{
					catid	: this.catid,
					page	: this.pageNum,
					limit	: this.pageSize
				},
				success:(res)=>{
					this.newsListInfo = res.data
					this.pageLen = Math.ceil(res.data.list.total/this.pageSize)
				},
				complete:()=>{
					this.listLoading = false
				}
			})
		},
		//切换分页
		changeList(num){
			if(num<=0){return}
			if(num>this.pageLen){return}
			this.pageNum = num
			this.getListInfo()
		},
		
	}
}
</script>

<style lang="less" scoped>
.list-page{ background:url(../../assets/img/detail-bg.jpg) repeat-y center top; background-size:1920px auto;  padding-top:0;}
.tit-img{text-align:center; padding:50px 0;}
.list-cont{
	padding:0 50px;
	.list-side{
		width:360px; float:right; margin-left:30px;
		.side-item{
			padding:10px 0 30px;
			h3{font-size:20px; line-height:20px; color:#1E2533; margin-bottom:20px; }
			.list{
				background: #FFFFFF; box-shadow: 0px 5px 30px 0px rgba(2, 15, 70, 0.08); box-sizing: border-box; padding:20px 30px;
				li{
					font-size:16px; color:#637584; line-height: 40px; cursor: pointer; display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; 
					&:hover{color:#2A82EF; text-decoration: underline;}
				}
			}
		}
	
	}
	.list-main{
		.news-list{
			li{ 
				height:46px; line-height:46px; overflow:hidden; border-bottom:1px dotted #999;
				.date{font-size:14px; color:#999; line-height:46px; float:right; }
				.dot{ float:left; width:10px; height:10px; background:#3399ff; margin-top:20px; margin-right:15px; }
				p{font-size:16px; color:#666; line-height:46px;display: block; text-overflow:ellipsis; white-space:nowrap; overflow:hidden; cursor: pointer;
					&:hover{color:#e83d27;}
				}
				&:last-child{border-bottom:none;}
			}
		}
	
		.paging{
			padding:40px 0; text-align:center ;
			p{margin-left:10px; font-size:20px; color:#666; line-height:40px; display:inline-block;  vertical-align: top;}
			span{
				height:40px; width:40px; display:inline-block; box-sizing: border-box; border:1px solid #F0F0F0; display:inline-flex; align-items: center; justify-content: center; font-size:16px; color:#999999; margin:0 5px; cursor: pointer;
				&.prev,
				&.next{ width:70px; }
				&:hover,
				&.act{background:#2A82EF; color:#fff; border-color:#2A82EF;}
			}
		}
	}
}




</style>



// WEBPACK FOOTER //
// src/pages/list/index.vue